import React from 'react';
import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';

const LABELS = {
  users: 'Kullanıcı',
  new_users: 'Yeni Kullanıcı',
  returning_users: 'Geri Dönen Kullanıcı',
  sessions: 'Oturum',
  page_views: 'Sayfa Görüntüleme',
  whatsapp_clicks: 'WhatsApp Tıklaması',
  phone_clicks: 'Telefon Tıklaması',
  booking_starts: 'Rezervasyona Başlama',
  bookings_completed: 'Tamamlanan Rezervasyon',
};

const Delta = ({ item }) => {
  if (item.pct === null) return <span className="text-xs text-gray-400">Önceki dönem verisi yok</span>;
  const up = item.diff > 0;
  const Icon = item.diff === 0 ? Minus : up ? ArrowUpRight : ArrowDownRight;
  const color = item.diff === 0 ? 'text-gray-500' : up ? 'text-green-600' : 'text-red-600';
  return (
    <span className={`inline-flex items-center gap-1 text-xs font-semibold ${color}`}>
      <Icon size={14} /> {item.diff > 0 ? '+' : ''}{item.diff} ({item.pct > 0 ? '+' : ''}{item.pct}%)
    </span>
  );
};

export const StatCards = ({ summary, active }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4" data-testid="stats-cards">
    <div className="rounded-2xl bg-gray-900 text-white p-4" data-testid="stat-active-30">
      <p className="text-xs text-gray-300">Son 30 dk aktif kullanıcı</p>
      <p className="text-3xl font-bold font-ui mt-1">{active}</p>
      <span className="text-xs text-gray-400">Canlı</span>
    </div>
    {Object.entries(LABELS).map(([key, label]) => (
      <div key={key} className="rounded-2xl bg-white border border-gray-100 p-4" data-testid={`stat-${key}`}>
        <p className="text-xs text-gray-500">{label}</p>
        <p className="text-3xl font-bold font-ui text-gray-900 mt-1">{summary[key]?.current ?? '–'}</p>
        {summary[key] && <Delta item={summary[key]} />}
      </div>
    ))}
  </div>
);
